export enum TreeNodeMutateOptions {
  'UPDATE',
  'ADD',
  'DELETE',
}
